var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"take-action-button flex-centerize",on:{"click":function($event){$event.preventDefault();return _vm.onActionClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('SIcon',{staticClass:"ml-1",attrs:{"name":"take-action-chevrons"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }